/* LG PLP sidebar toggle — desktop filters-rail open/close (16-07-26 PLP reorganization).
 *
 * Morph-proof by design (horizon-mechanics §1.25): the open/closed STATE lives as a
 * class on <body> — carrier 1, outside the morphed `#shopify-section-*` subtree — plus
 * sessionStorage (mirrors Horizon's grid-density precedent, assets/results-list.js).
 * The server-emitted toggle button (blocks/filters.liquid, vertical top controls bar)
 * carries `data-skip-node-update` so its JS-set aria-expanded survives facet morphs
 * (carrier 3). Click handling is delegated on `document`, so nothing needs re-binding
 * when Section Rendering replaces the button node.
 *
 * NO filtering/count/facet logic lives here — counts and facet UI are server-emitted
 * Liquid re-rendered by Horizon's facets.js morph loop (§1.13 / §1.24).
 */

const BODY_CLASS = 'lg-plp-filters-open';
const STORE_KEY = 'lg-plp-filters-open';

function isOpen() {
  return document.body.classList.contains(BODY_CLASS);
}

function syncToggleButtons() {
  const expanded = isOpen() ? 'true' : 'false';
  for (const button of document.querySelectorAll('[data-lg-plp-toggle]')) {
    button.setAttribute('aria-expanded', expanded);
  }
}

function setOpen(open) {
  document.body.classList.toggle(BODY_CLASS, open);
  try {
    sessionStorage.setItem(STORE_KEY, open ? '1' : '0');
  } catch {
    /* storage unavailable (private mode / blocked) — state stays per-pageview */
  }
  syncToggleButtons();
}

/* Restore per-session state before first paint of interactions. Default is CLOSED
   (owner-ratified G1 decision 2) — only an explicit stored "open" adds the class. */
try {
  if (sessionStorage.getItem(STORE_KEY) === '1') {
    document.body.classList.add(BODY_CLASS);
  }
} catch {
  /* noop */
}
syncToggleButtons();

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const toggle = event.target.closest('[data-lg-plp-toggle]');
  if (!toggle) return;
  setOpen(!isOpen());
});
